import { channelTypeInfo } from "../models/ChannelType";
import { itx } from "../translationItx/itx";
import AddressGeneratorUtils from "./AddressGeneratorUtils";
import { createButtonAddresses_3 } from "./createButtonAddresses";
import generateAddressesForConsumer_3 from "./generateAddressesForConsumer_3";
import generateAddressesForConsumer_B from "./generateAddressesForConsumer_B";

// Diese Funktion generiert die knx Adressen nach dem Muster
// Group Address Hierarchy:  (Etage/Raum) / Consumer / Signal

export function createAddresses_A() {
  let roomAddrIndex = 1;

  state.floors.sortBy("tagOrName").forEach((floor) => {
    floor.rooms.sortBy("tagOrName").forEach((room) => {
      if (room.isFloorGeneralRoom && room.buttons.size == 0 && room.consumers.size == 0) {
        //
        // Skip general floor rooms without buttons or consumers
        //
        return;
      }

      // Level 1 Address (Etage-Raum)

      let roomName = room.name;
      if (room.isFloorGeneralRoom) {
        roomName = itx("createAddressesA.allgemein", "Allgemein");
      }
      //
      // Level 1 Address (Etage-Raum)
      //
      const roomGroup = AddressGeneratorUtils.getOrCreateAddressByName({
        level: 1,
        tag: room.fullTag,
        name: `${floor.tag} ${roomName}`,
        address: `${roomAddrIndex}`,
        parent: state.addresses,
      });

      const sortedButtons = room.buttons.sortBy("tag");

      const sortedConsumers = room.consumers.sortBy("tag").filter((c) => !channelTypeInfo(c.channelType).isSupply);

      if (sortedConsumers.length > 7) {
        //
        // Zuviele Consumer in einem Raum
        // Wir verweden in diesem Falle  für die 2. Ebene das Muster von "Schema B" (Functionen)
        //
        sortedConsumers.forEach((consumer) => {
          generateAddressesForConsumer_B(consumer, roomGroup);
        });
      } else {
        sortedConsumers.forEach((consumer) => {
          const name = `${consumer.tag} ${consumer.name}`;

          //
          // Level 2 Address (Consumer)
          //

          let consumerGroupAddressGroup = consumer.groupAddress;
          if (consumerGroupAddressGroup) {
            //
            // may currently reside only in mainGroup.children.lastItems
            //
            roomGroup.children.addWithoutUpdate(consumerGroupAddressGroup);
            consumerGroupAddressGroup.name = name;
          } else {
            const address2 = roomGroup.children.size;

            consumerGroupAddressGroup = AddressGeneratorUtils.getOrCreateGroupAddressByAddress({
              level: 2,
              tag: consumer.tag, // no itx
              name: `${consumer.tag} ${consumer.name}`,
              address: `${address2}`,
              parent: roomGroup,
            });
            consumer.groupAddress = consumerGroupAddressGroup;
          }

          generateAddressesForConsumer_3(consumer, consumerGroupAddressGroup);
        });
      }

      //
      // Alle Button GruppenAddresen (für GruppenTasten) gehen nach "31/6/**"

      const group31 = state.addresses.findFirst((a) => a.address == "31");
      if (!group31) {
        console.error("Group 31 not found");
        return;
      }

      let groupButtons = AddressGeneratorUtils.getOrCreateGroupAddressByAddress({
        level: 2,
        tag: "T",
        name: itx("createAddresses.buttons", "Tasten"),
        address: `6`,
        parent: group31,
      });

      sortedButtons.forEach((button) => {
        createButtonAddresses_3(button, groupButtons);
      });
    });
  });
}
